export default "__VITE_ASSET__Y7YuXpXy__"